// eslint-disable-next-line
/* eslint-disable */

import { api } from './config'
var sha1 = require('sha1');

export default {
    usuario: {
        login(user) {
            var obj = {
                password: sha1(user.password),
                username: user.username,
            }
            return api.post('/login', obj)
        },
        buscarIdPorCPF(cpf) {            
            return api.get(`/buscarIdPorCPF?cpf=${cpf}`)
        },
        redefinirSenha(obj) {
            console.log('redefinir senha: ', obj);
            
            return api.post('/resetarSenha', obj)
        },
        frontendInicializado() {
            var obj = {
                frontendInicializado: 'frontendInicializado',
            }
            return api.post('/frontendInicializado', obj)
        },

        register(user) {
            console.log(user);
            return api.post('/medico/register', user)
        },


    }
}
